<div class="topbar">
  @if (layout.isCompact()) {
    <a class="topbar__brand" routerLink="/radios" aria-label="HX Player home">
      <mat-icon fontSet="material-icons-outlined">graphic_eq</mat-icon>
    </a>
  }

  <search-component></search-component>

  <button
    type="button"
    class="topbar__surprise"
    (click)="surpriseMe()"
    aria-label="Play a random station"
    matTooltip="Play a random station"
  >
    <mat-icon>shuffle</mat-icon>
    <span class="topbar__surprise-label">Surprise me</span>
  </button>
</div>
